import {getLocalData, setLocalData} from "./StorageServices";

const _keyStore = 'histories';
let _subscribers = [];

export const subscribeHistories = (callback) => {
    if (_subscribers.indexOf(callback) !== -1) {
        return false;
    }

    _subscribers = [].concat(_subscribers, callback);

    return true;
};

export const unsubscribeHistory = (callback) => {
    _subscribers = _subscribers.filter(subscribe => subscribe !== callback);

    return true;
};

const _broadcast = () => {
    _subscribers.forEach(subscribe => {
        typeof subscribe === 'function' && subscribe();
    });
};

export const getHistories = () => {
    const histories = getLocalData(_keyStore);

    if (!histories || !Array.isArray(histories)) {
        return [];
    }

    return histories.filter(history => history.id);
};

export const insertNewHistory = (text) => {
    const histories = getHistories();
    const {length} = histories;

    const index = length ? histories[0].id : 0;

    const newHistory = {
        id: index + 1,
        text,
    };

    const _histories = histories.filter(_history => {
        return text !== _history.text;
    });

    const newHistories = [].concat([newHistory], _histories);
    if (newHistories.length > 10) {
        newHistories.pop();
    }

    setLocalData(_keyStore, newHistories);
    _broadcast();

    return newHistories;
};

export const removeHistory = (id) => {
    const histories = getHistories();

    const newHistories = histories.filter(history => history.id !== id);
    setLocalData(_keyStore, newHistories);
    _broadcast();

    return newHistories;
};


// WEBPACK FOOTER //
// ./src/services/HistoryServices.js